import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const DebugToolsRoutes = defineRoute({
    database: {
        route: {
            path: "/debug-tools/database",
            component: () => loadView(import("./DebugToolsDatabaseHome.vue")),
        },
        debug: true,
    },
});
